import React from "react";
import Nav from "./Components/Nav";
import Footer from "./Components/Footer";
import CHFrBusinessSolutionBody from "./Components/BodyFrBusinessSolution";

class CHFrBusinessSolution extends React.Component {
  render() {
    return (
      <>
        <Nav />
        <CHFrBusinessSolutionBody />
        <Footer />
      </>
    );
  }
}

export default CHFrBusinessSolution;
